import { consoleLogger } from '@shared/logging/consoleLogger';
import { getEventFieldsTemplate } from './getEventFieldsTemplate';
import { validateTemplate } from '../validation/validateTemplate';
import { UtiqEvents } from './events';

/**
 * @param {string} eventName
 * @param {"Utiq"} environment
 * @param {object} data
 */
export const callEventListeners = (eventName, environment, data = {}) => {
  const fieldsTemplate = getEventFieldsTemplate(environment, eventName);
  const { isValid } = validateTemplate({
    fieldsTemplate,
    validationTargetObject: data,
    logIdentificator: eventName,
  });

  /* wasCalledAlready is an entry that returns true if the event should be triggered once per session and already was, in other cases is undefined */
  if (isValid && !UtiqEvents[eventName]?.wasCalledAlready?.()) {
    if (UtiqEvents[eventName]) {
      window.Utiq ||= {};
      window.Utiq.events ||= {};
      window.Utiq.events[eventName] ||= {};
      window.Utiq.events[eventName].lastCall = { data, environment };
    }
    const listeners = window.Utiq?.listeners?.[eventName] || [];
    if (!Array.isArray(listeners)) {
      consoleLogger.logDebug(
        `Listeners for ${eventName} in the ${environment} environment are not an array. Cannot publish the event...`,
      );
      return;
    }
    try {
      listeners.forEach((listenerCallback) => {
        listenerCallback(data, environment);
      });
    } catch (err) {
      consoleLogger.logDebug(
        `Error occurred when processing ${eventName} listeners in the ${environment} environment. Description: ${err}.`,
      );
    }
  }
};
